import './index.css';
import App from './App';
import React from 'react';

import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { ToastContainer } from 'react-toastify';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { store } from 'redux/store/store';
import { QueryClient, QueryClientProvider } from 'react-query';
import applyBranding from 'lib/branding';

// title / description / favicon for the tenant this host belongs to,
// before the first paint. Refined again once the org config is fetched.
applyBranding();

const queryClient = new QueryClient({

  defaultOptions: {
    mutations: {
      retry: false,
      // since we do not need the cache of mutation, we are disable cache of mutation
      // cacheTime: 0,
    },
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      // Time to stale request and re-fetch in background
      staleTime: 1 * 1000,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Router basename="/">
          <App />
          <ToastContainer
            position="bottom-right"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Router>
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();
